export const UPLOAD_FILE_SUCCESS="resource/UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE="resource/UPLOAD_FILE_FAILURE"
export const GET_RESOURCE_SUCCESS="resource/GET_RESOURCE_SUCCESS";
export const GET_RESOURCE_FAILURE="resource/GET_RESOURCE_FAILURE"
export const GET_PDF_METADATA_SUCCESS="resource/GET_PDF_METADATA_SUCCESS";
export const GET_PDF_METADATA_FAILURE="resource/GET_PDF_METADATA_FAILURE";
export const GET_PDF_LIST_SUCCESS="resource/GET_PDF_LIST_SUCCESS";
export const GET_PDF_LIST_FAILURE="resource/GET_PDF_LIST_FAILURE";